/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface S3KeyPrefixInformation { 
    /**
     * The S3 key prefix to use when writing or accessing the data. Note that the S3 key prefix will not contain a trailing                   \"directory\" separator and it will be up to the caller to append one as needed                
     */
    s3KeyPrefix: string;
}
